/**
 * This code has been taken from https://github.com/facebook/react/blob/master/packages/shared/ExecutionEnvironment.js
 */
export const canUseDom = !!(
  typeof window !== "undefined" &&
  typeof window.document !== "undefined" &&
  typeof window.document.createElement !== "undefined"
);
